export default __webpack_public_path__ + "static/media/unliked.c31d61db.svg";